import { Store } from 'pullstate';

export const PaymentStore = new Store({
    cartItemsPayment: [],
    outletIdPayment: '',
    dateTimePayment: null,
    orderTypePayment: '',
    timestampPayment: null,
});
